import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import diplomats_Campaigner_ENFP_personality_header from '../../images/personality_types_details/diplomats_Campaigner_ENFP_personality_header.svg'
import diplomats_Campaigner_ENFP_introduction from '../../images/personality_types_details/diplomats_Campaigner_ENFP_introduction.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'

const enfp_personality = () => {
    return (
        <Layout>
            <main class="q-td analyst campaigner">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/compaigner-enfp-personality' className="tab with-progress active">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-strengths-and-weaknesses" className="tab with-progress ">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-friends" className="tab with-progress ">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-careers" className="tab with-progress ">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfps-at-work" className="tab with-progress ">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header class="type-header diplomat campaigner">

                    <svg class="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path class="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path class="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>

                    <img src={diplomats_Campaigner_ENFP_personality_header} class="scene" alt='loading...' />
                    <div class="type-info">
                        <h1><span>Campaigner</span> Personality</h1>
                        <div class="code">ENFP-A / ENFP-T</div>
                        <a href="#" class="difference">(What’s the difference?)</a>
                    </div>

                </header>

                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className="active"><Link to='/personality-types/compaigner-enfp-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-parents">Parenthood</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfps-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                        <h1>Introduction</h1>


                        <div class="definition">
                            <p class="title">Who is A Campaigner (ENFP)?</p>
                            <p>A <dfn>Campaigner (ENFP)</dfn> is someone with the <a class="with-border" href="articles/mind-introverted-vs-extraverted.html">Extraverted</a>, <a class="with-border" href="articles/energy-intuitive-vs-observant.html">Intuitive</a>, <a class="with-border" href="articles/nature-thinking-vs-feeling.html">Feeling</a>, and <a class="with-border" href="articles/tactics-judging-vs-prospecting.html">Prospecting</a> personality traits. These people tend to embrace big ideas and actions that reflect their sense of hope and goodwill toward others. Their vibrant energy can flow in many directions.</p>
                        </div>


                        <blockquote>
                            <p>It doesn’t interest me what you do for a living. I want to know what you ache for – and if you dare to dream of meeting your heart’s longing. It doesn’t interest me how old you are. I want to know if you will risk looking like a fool – for love – for your dreams – for the adventure of being alive.</p>
                            <footer>Oriah Mountain Dreamer</footer>
                        </blockquote>

                        <p>The Campaigner personality is a true free spirit. They are often the life of the party, but unlike types in the Explorer Role group, Campaigners are less interested in the sheer excitement and pleasure of the moment than they are in enjoying the social and emotional connections they make with others. Charming, independent, energetic and compassionate, the 7% of the population that they comprise can certainly be felt in any crowd.</p>

                        <div class="scene">
                            <img alt="Campaigner personality" src={diplomats_Campaigner_ENFP_introduction} alt="Campaigner personality" />
                        </div>

                        <h2>You Can Change the World With Just an Idea</h2>

                        <p>More than just sociable people-pleasers though, Campaigners, like all their Diplomat cousins, are shaped by their Intuitive (N) quality, allowing them to read between the lines with curiosity and energy. They tend to see life as a big, complex puzzle where everything is connected – but unlike Analyst personality types, who tend to see that puzzle as a series of systemic machinations, Campaigners see it through a prism of emotion, compassion and mysticism, and are always looking for a deeper meaning.</p>

                        <div class="description-pullout">Campaigners are fiercely independent, and much more than stability and security, they crave creativity and freedom.</div>

                        <p>Many other types are likely to find these qualities irresistible, and if they’ve found a cause that sparks their imagination, Campaigners will bring an energy that oftentimes thrusts them into the spotlight, held up by their peers as a leader and a guru – but this isn’t always where independence-loving Campaigners want to be. Worse still if they find themselves beset by the administrative tasks and routine maintenance that can accompany a leadership position. Campaigners’ self-esteem is dependent on their ability to come up with original solutions, and they need to know that they have the freedom to be innovative – they can quickly lose patience or become dejected if they get trapped in a boring role.</p>

                        <h2>Don’t Lose That ’Little Spark of Madness’</h2>

                        <p>Luckily, Campaigners know how to relax, and they are perfectly capable of switching from a passionate, driven idealist in the workplace to that imaginative and enthusiastic free spirit on the dance floor, often with a suddenness that can surprise even their closest friends. Being in the mix also gives them a chance to connect emotionally with others, giving them cherished insight into what motivates their friends and colleagues. They believe that everyone should take the time to recognize and express their feelings, and their empathy and sociability make that a natural conversation topic.</p>

                        <p>The Campaigner personality type needs to be careful, however – if they rely too much on their intuition, assume or anticipate too much about a friend’s motivations, they can misread the signals and frustrate plans that a more straightforward approach would have made simple. This kind of social stress is the bugbear that keeps harmony-focused Diplomats awake at night. Campaigners are very emotional and sensitive, and when they step on someone’s toes, they both feel it.</p>

                        <p>Campaigners will spend a lot of time exploring social relationships, feelings and ideas before they find something that really rings true. But when they finally do find their place in the world, their imagination, empathy and courage are likely to produce incredible results.</p>

                        <div class="number">01</div>


                    </article>


                </div>
                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                    </div>
                    <div className="part right">
                        <Link to='/personality-types/compaigner-enfp-strengths-and-weaknesses' className='next-feature'>
                            Strengths & Weaknesses
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>
            </main>
        </Layout>
    )
}

export default enfp_personality
